import React from "react";
import "./ReasonTag.scss";

export type ReasonTagVariant = "solid" | "outline" | "dashed";

export interface ReasonTagProps {
    /** Full reason text; passed to onTap. */
    text: string;
    variant: ReasonTagVariant;
    /** Renders filled/highlighted when true. */
    selected: boolean;
    /** Fired on tap with the full text; parent decides select vs deselect. */
    onTap: (text: string) => void;
    /** Visible label when it should differ from text (e.g. truncated). */
    label?: string;
}

/** Presentational toggle pill. The parent owns selection; onTap always receives the full text. */
const ReasonTag: React.FC<ReasonTagProps> = ({ text, variant, selected, onTap, label }) => {
    const stateClass = selected ? "reason-tag--selected" : `reason-tag--${variant}`;

    return (
        <button
            type="button"
            className={`reason-tag ${stateClass}`}
            aria-pressed={selected}
            onClick={() => onTap(text)}
        >
            <span className="reason-tag__text">{label ?? text}</span>
        </button>
    );
};

export default ReasonTag;
